<template>
    <div class="image-picker">
        <div class="image-preview">
            <a v-if="has_image" @click.prevent="clear()" class="image-preview__close" href="#">
                &times;
            </a>

            <div class="image-preview__panel" v-bind:class="{ 'has-image': has_image }" :style="{backgroundColor:bg_color}">
                <!-- <b-alert class="image-preview__alert" :show="alert.visible" :variant="alert.variant">
                    {{ alert.message }}
                </b-alert> -->

                <span v-if="has_dimension_props && !has_image" class="image-preview__dimensions">
                    {{ height }}px x {{ width }}px
                </span>

                <img v-bind:src="img_src" ref="image">
            </div>

            <span class="image-preview__info">
                <div v-if="filename">
                    {{ filename }}
                </div>

                <label v-else v-bind:for="'file-picker-' + _uid">Upload an image</label>
            </span>
        </div>
        
        <input v-bind:id="'file-picker-' + _uid"
            type="file" 
            accept="image/*" 
            ref="filepicker" 
            @change="filePicked">
    </div>
</template>

// <script>
//     import alert from '@/mixins/alert.js';
    import resizeImage from 'resize-image';

    export default {
    //     mixins: [ alert ],

        props: [
            'current_image_url',
            'height',
            'width',
            'bg_color'
        ],

        data() {
            return {
                max_filesize_mb: 10,
                file: null,
                filename: "",
                img_src: ""
            }
        },

        computed: {
            img_el() {
                return this.$refs.image;
            },

            has_image() {
                return this.img_src.length > 0;
            },

            max_filesize() {
                return this.max_filesize_mb * 1000000;
            },

            image_is_exact_dimensions() {
                return (this.img_el.naturalHeight == this.height && this.img_el.naturalWidth == this.width);
            },

            has_dimension_props() {
                return (this.height !== undefined && this.width !== undefined);
            },

            should_resize_image() {
                return (this.has_dimension_props && !this.image_is_exact_dimensions);
            },

            messages() {
                return {
                    filesize_message: "Image over " + this.max_filesize_mb + "mb. Please submit a smaller image.",
                    dimensions_message: "Image too small. Please submit an image with minimum dimensions of " + this.width + "px width by " + this.height + "px height."
                }
            },

            base64() {
                return this.getBase64FromSrc(this.img_src);
            }
        },

        methods: {
            clear() {
                this.file = null;
                this.filename = null;
                this.img_src = "";
                this.$refs.filepicker.value = "";
            },

            filePicked(e) {
                this.loadAndValidate(e.target.files[0], () => {
                    this.$emit('image-picked', this.base64);
                });
            },

            loadAndValidate(file, successCallback = null) {
                /*
                    Load the file async. On callback, validate the filesize. 
                    If pass, watch for img load - on load, validate dimensions.
                    If pass and image larger than required dimensions (if they are set
                    in props), resize.
                */

                this.file = file;
                this.filename = file.name;

                this.loadFile(this.file, (e) => { // async wait for FileReader, callback
                    this.img_src = e.target.result;

                    if (!this.validateFileSize()) {
                        // this.showAlert(false, this.messages.filesize_message);
                        this.clear();
                        return;
                    }

                    this.img_el.onload = () => { // async wait for image to load src
                        if (this.validateDimensions()) {
                            if (this.should_resize_image) {
                                // this.showAlert(true, "Successfully uploaded image. Resizing.");
                                this.resize();
                            }

                            if (successCallback) successCallback();
                            
                        } else {
                            // this.showAlert(false, this.messages.dimensions_message);
                            this.clear();
                        }
                    }
                });
            },

            loadFile(file, callback) {
                let reader = new FileReader();

                reader.onload = (e) => {
                    window.e = e;
                    callback(e);
                }

                reader.readAsDataURL(file);
            },

            validateFileSize() {
                return (this.file.size <= this.max_filesize);
            },

            validateDimensions() {
                if (!this.has_dimension_props) return true; // default pass if no dimensions set

                return (this.img_el.naturalHeight >= this.height && this.img_el.naturalWidth >= this.width);
            },

            resize() {
                this.img_src = resizeImage.resize(this.img_el, this.width, this.height);
                this.setFileFromBase64(this.img_src);
            },

            getBase64FromSrc(src) {
                // let i = src.indexOf('base64,');
                // return src.slice(i + 7);
                return src;
            },

            setFileFromBase64(base64) {
                let b = this.getBase64FromSrc(base64);

                this.file = new File([b], this.filename, {
                    type: this.file.type
                });
            }
        },

        created() {
            if (this.current_image_url) {
                this.img_src = this.current_image_url;
                this.filename = this.img_src.substring(this.current_image_url.lastIndexOf('/') + 1);
            }
        }
    }
</script>

<style scoped lang="scss">
    .image-picker {
        max-width: 100%;
        //width: 200px;

        @media (max-width: 767px) {
            width: 100%;
        }
    }

    .image-preview {
        position: relative;

        &__close,
        &__close:hover {
            font-size: 25px;
            color: white;
            text-decoration: none;
            position: absolute;
            top: 10px;
            right: 10px;
            z-index: 1;
            background-color: #007bff;
            border-radius: 100px;
            padding: 0 10px;
        }

        &__close:hover {
            background-color: #0069d9;
        }

        &__panel {
            width: 100%;
            height: 200px;
            background-color: #e9e9e9;
            position: relative;

            &.has-image {
                height: initial;
                padding: 1rem;
            }
        }

        &__dimensions {
            position: absolute;
            width: 100%;
            top: 50%;
            text-align: center;
        }

        &__alert {
            position: absolute!important;
            margin: 0!important;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            border-radius: 0!important;
            z-index: 1;
        }
        
        &__info {
            display: block;
            text-align: center;
            width: 100%;
            color: white;

            label, div {
                width: 100%;
                background-color: #007bff;
                padding: 10px;
            }

            label {
                cursor: pointer;
                margin: 0;

                &:hover {
                    background-color: #0069d9;
                }
            }
        }

        img {
            width: 100%;
        }
    }

    input[type='file'] {
        display: none;
    }
</style>